export default "__VITE_ASSET__BXWDNWAi__"